import * as React from 'react'
import * as ReactDOM from 'react-dom'
import GlobalOptionsInterface from './types/global-options'
import ConfigProvider from 'antd/lib/config-provider'
import ru_RU from 'antd/es/locale/ru_RU'
import App from './components/app'
import mergeDeep from '../../../common/helpers/merge-deep'
import defaultGlobalOptions from './constants/global-options'
import {renderToString} from 'react-dom/server'

declare const window
declare const ENV_IS_DEV: boolean

window.TravelCalculator = class TravelCalculator {
    constructor(nodeId: string, initOptions: GlobalOptionsInterface) {
        const globalOptions = mergeDeep({}, initOptions, defaultGlobalOptions)

        ReactDOM.render(
            <ConfigProvider locale={ru_RU}>
                <App globalOptions={{...globalOptions, rootNodeId: nodeId}} />
            </ConfigProvider>,
            document.getElementById(nodeId)
        )
    }
}

/**
 * Эта функция необходима для рендера в html
 * на этапе сборки калька
 */
export default () => {
    const html = renderToString(
        <ConfigProvider locale={ru_RU}>
            <App globalOptions={{...defaultGlobalOptions, rootNodeId: 'root'}} />
        </ConfigProvider>
    )
    return html
}

// страны 22.144px
// заголовки 34.448px
// кнопка 22.144px
// текст 19.68px
// отзывы 17.216px
// отзывы 14.768px
// в плашках 27.072px
// кальк чек 15px
// кальк цена 48px
// кальк инпуты 17px
